import { PushesState, PushesPushAction, PushesCloseAction } from './interface';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';

const initialState: PushesState = {
  items: [],
};

let pushId = 0;

export const { actions, reducer } = createSlice({
  name: 'pushes',
  initialState,
  reducers: {
    push(state, action: PushesPushAction) {
      state.items.push({
        ...action.payload,
        createdAt: Date.now(),
        ttl: action.payload.ttl || 10000, // time to live | ms
        id: ++pushId,
      });
    },
    close(state, action: PushesCloseAction) {
      const id = action.payload;
      if (id) {
        state.items = state.items.filter((p) => p.id != id);
      }
    },
  },
});

export { reducer as pushesReducer, actions as pushesActions };

export const pushesSelector = (state: RootState) => state.pushes;
